import React, { useEffect, useState, useCallback, createRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-modal';
import { hide } from '../../Actions/Accessory.action';
import AccessoryProductCard from '../ProductCards/AccessoryProductCard';
import StyledAccessoryBuyButton from '../AccessoryBuyButton'
import { translate } from '../../Services/translation';

 const customStyles = {
    content: {
      background: '#F6F6F4',
      padding: 0,
      border: 'none',
      height: '80%',
      width: '50%',
      display: 'flex',
      justifyContent:'center',
      alignSelf:'center',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 2003,
  },
 };

const AccessoryModal = (checkoutUrl) => {
  var dispatch = useDispatch();
  const accessoryItems = useSelector((state) => state.accessory) || {};
  const onClose = useCallback(() => dispatch(hide(false)), [dispatch]);

  return (
    <>
      {accessoryItems && accessoryItems.visible &&
        <Modal
          ariaHideApp={false}
          preventScroll={true}
          isOpen={accessoryItems.visible}
          onRequestClose={onClose}
          shouldCloseOnOverlayClick={false}
          className="accessory-modal-content"
          overlayClassName="accessory-overlay"
        >
          <button
            onClick={onClose}
            className="accessory-modal__close-btn"
          >
            &times;
          </button>
          <div className='accessory-wrapper'>
          <div className='accessory-text--wrapper'>
          <div className='accessory-title'><h2>{translate('accessory.title')}</h2></div>
          <div className='accessory-description'>{translate('accessory.description')}</div>
          </div>
          <div className='accessory-product-card-wrapper'>
          {accessoryItems.accessories.map((item, i) =>
            <AccessoryProductCard key={i}
              {...item}  />          
          )}
          </div>
          <div className='accessory-buttons'>
              <div className="accessory-buttons-back">
                <button
                  onClick={onClose}
                  className={"back-button"}
                  type='button'
                >
                  {translate('accessory.keepbrowse')}

                </button>
              </div>
              <div className="accessory-buttons-checkout">
              <a href={accessoryItems.accessories[0].checkoutUrl} className="checkout-button">{translate('accessory.checkout')}</a>
              </div>
          </div>
          </div>
        </Modal>
      }
    </>

  );
};

export default AccessoryModal;